module.exports = __webpack_public_path__ + "static/media/ic_categories_book.a142e81d.svg";